export default __webpack_public_path__ + "static/media/up-arrow.f2b9a351.svg";